import { createFileRoute } from "@tanstack/react-router";

import { ProfileSummary } from "@/components/profiles";

const ProfileSummaryPage = () => {
  return <ProfileSummary />;
};

export const Route = createFileRoute("/_private/profiles/$id/")({
  component: ProfileSummaryPage,
});
